var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwareMobil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.04 28.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "My Software mobil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.65,
    y: 21.58,
    width: 15.99,
    height: 19.71,
    transform: "translate(47.69 48.53) rotate(180)",
    fill: "#b4ccdd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.83,
    y: 7.25,
    width: 9.22,
    height: 19.71,
    fill: "#05548e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61,14.33V42.58h27V14.33Zm25,26.25h-23v-18h23Z",
    transform: "translate(-11.61 -14.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.83,
    y: 2.8,
    width: 22.83,
    height: 2.65,
    fill: "#05548e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareMobil);
export default __webpack_public_path__ + "static/media/software-mobil.575ef93b833688c31b45b1b2e27b71d2.svg";
export { ForwardRef as ReactComponent };